import * as React from 'react';
import { Image, FlatList, StyleSheet, Text, TouchableOpacity, View, Linking, Dimensions, ImageBackground} from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import NewButton from '../components/NewButton';
import Header from '../components/Header';
import {Fonts} from '../utils/Constants';
import ReactGA from 'react-ga';

export default class AboutScreen extends React.PureComponent{
  constructor(props){
    super(props);
    this.state= {
      width: Dimensions.get('window').width,
      height: Dimensions.get('window').height,
      campaigns: []
    }
    Dimensions.addEventListener("change", this.handler);
    ReactGA.pageview('/about');
  }

  handler = (dims) => {
    this.setState({
      width: dims.window.width,
      height: dims.window.height,
    });
  }

  componentWillUnmount() {
    // Important to stop updating state after unmount
    Dimensions.removeEventListener("change", this.handler);
  }

  render(){
    let widthCutoff = 1207;
    let styling = {};
    let screenWidth = this.state.width >=1207 ? 1067 : this.state.width;
    if (this.state.width >=widthCutoff){
      styling.width = this.state.width >= 1207 ? 1067 : '75%',
      styling.layout = 'row';
      styling.screenWidth = '100%';
      styling.infoView = {flex: 1, paddingRight: '5%', width: '90%'};
      styling.image = {
        flex: 1,
        height: 400,
        resizeMode: 'contain'
      };
    } else {
      styling.width = this.state.width >= 1067 ? 1067 : '90%';
      styling.layout = 'column';
      styling.screenWidth = '90%';
      styling.infoView = {width: '100%'};
      styling.image = {
        marginTop: '5%',
        height: this.state.width >=650 ? 400 : this.state.width * 0.6,
        width: '80%',
        resizeMode: 'contain'
      };
    }

    //dimension ratio is 1 (width) by 0.75 (height)
    let cardSize = {width: screenWidth*0.40, height: screenWidth*0.3, numColumns: 2}
    if (screenWidth <= 800 && screenWidth >= 500) {
      cardSize = {width: screenWidth*0.8, height: screenWidth*0.6, numColumns: 1}
    } else if (this.state.width < 500) {
      cardSize = {width: screenWidth*0.9, height: screenWidth*0.68, numColumns: 1}
    }

    return (
      <ScrollView contentContainerStyle={styles.contentContainer}>
        <View
            style={{width: '100%', alignItems: 'center', paddingTop: 10, paddingBottom: 40, marginBottom: screenWidth >=500 ? 30: 20, backgroundColor: '#6B72A0'}}
            // imageStyle={{ width: '100%', overflow: 'hidden'}}
            // source={require('../assets/images/dyp_gradient.svg')}
        >
        <Header color={'white'} navigation={this.props.navigation} width = {styling.width} screenWidth={this.state.width}/>
        <View style={{width:styling.width}}>
          <Text style={[{color: 'white'}, styles.topBlurbText, {fontSize: screenWidth >= 500 ? 40 : 30}]}>
            About
          </Text>
        </View>
        </View>
          <View style={{width: screenWidth >= 1067 ? 1067:'80%'}}>
            <Text style={[styles.titleText, {fontSize: screenWidth >=500 ? 29 : 18}]}>About DYP</Text>
            <Text style={[styles.lowerBlurbText]}>
              DoYourPart centralizes information and action resources for social justice movements and tracks the completion of tasks to increase awareness, education, and impact. Movements are organized by campaigns where users can take defined actions and produce quantifiable impact. In the end, users can share a receipt of what they have done through social media platforms.
            </Text>
            <Text style={[styles.titleText, {fontSize: screenWidth >=500 ? 29 : 18}]}>Our Mission</Text>
            <Text style={[styles.lowerBlurbText]}>
              To increase awareness, education, and quantifiable impact.
            </Text>
            <Text style={[styles.titleText, {fontSize: screenWidth >=500 ? 29 : 18}]}>Team</Text>
            <Text style={[styles.lowerBlurbText]}>
              Hi! Our team is a part of TPEO where we do social impact projects. Read more about TPEO in the section below.
            </Text>
            <Text style={[styles.lowerBlurbText, {marginTop: 15}, {marginBottom: 15}]}>
              Reach out to DoYourPart team if you want to start a campaign with us.
            </Text>
            <NewButton textColor='black' text='Contact Us' borderColor="black" borderWidth={1} width={192} height={37} fontFamily={Fonts.mainFont} font='600' action={() => Linking.openURL('https://forms.gle/4wqca6JHZnBPuvr27')}/>
            <FlatList
              style={{marginTop: 40, marginBottom: 20}}
              data={DATA}
              key={cardSize.numColumns}
              numColumns={cardSize.numColumns}
              renderItem={({ item }) => (
                <TouchableOpacity style={{padding: 20}} onPress={()=> window.open(item.link)}>
                  <Image
                  source={item.image}
                  style={{width: screenWidth >=500 ? 343: 260, height: screenWidth >=500 ? 343: 260, resizeMode: "fill", marginBottom: 10}}
                  />
                  <Text style={[styles.lowerBlurbText, {textDecorationLine: 'underline'}]} >
                    {item.name}
                  </Text>
                  <Text style={[styles.lowerBlurbText]} >
                    {item.description}
                  </Text>
                </TouchableOpacity>
              )}
            />
            <Text style={[styles.titleText, {fontSize: screenWidth >=500 ? 29 : 18}]}>Texas Product Engineering Organization</Text>
            <Text style={[styles.lowerBlurbText, {marginTop: 15}, {marginBottom: 15}]}>
              TPEO is a group of students at 🤠 UT Austin who are building, designing,
              and launching software products to solve real-world problems in our community.{"\n"}{"\n"}
              What we do:
              1. Teach full-stack engineering, UI/UX design, and product management in semester-long courses{"\n"}
              2. Provide hands-on experience through impactful projects and work at local startups{"\n"}
              3. Foster a community of innovators and builders who are going to change the world{"\n"}
            </Text>
            <Text style={[styles.titleText, {fontSize: screenWidth >=500 ? 29 : 18}]}>Our Partner: Simplified</Text>
            <View style={{flexDirection: screenWidth >=1000 ? 'row':'column', marginBottom: 70, alignItems: 'center'}}>
              <Text style={[styles.lowerBlurbText, {marginTop: 15}, {marginBottom: 15, marginRight: 30}]}>
              The goal of Simplified is, well, simple: to make politics accessible for everyone.{"\n"}{"\n"}
              When someone tells you they don’t vote, it’s typically because they feel they don’t know enough. That’s what we’re here to fix.
              Simplified offers a quick and easy way to learn about complex political issues and topics through short videos. We bring the content
              right to you on all of your favorite platforms so you can learn something new, feel more engaged with politics, and move on with your day.{"\n"}{"\n"}

              I’m Mitchell, a 23-year old California boy trying to make a difference and currently working
              on the Legislative Affairs team for Governor Gavin Newsom. I am a proud alumnus of Chapman
              University and a current Masters student at Northwestern University.
              </Text>
              <Image
                source={'https://doyourpart-assets.s3.amazonaws.com/mitchell.png'}
                style={{width: screenWidth >=500 ? 343: 260, height: screenWidth >=500 ? 343: 260, resizeMode: "fill", marginBottom: 10, marginTop: 20}}
                />
            </View>
          </View>
      </ScrollView>
    );
  }
}

const DATA = [
  {
    name: 'Jonathan Wong',
    description: "Product Manager & Engineer",
    image: 'https://doyourpart-assets.s3.amazonaws.com/jonathan.jpg',
    link: 'https://www.linkedin.com/in/jonathanwongut/',
  },
  {
    name: 'Josh Jones',
    description: "Engineer",
    image: 'https://doyourpart-assets.s3.amazonaws.com/josh.jpg',
    link: 'https://www.linkedin.com/in/josh-jones-624070152/',
  },
  {
    name: 'Kelly Zhou',
    description: "Product Manager & Engineer",
    image: "https://doyourpart-assets.s3.amazonaws.com/kelly.jpg",
    link: 'https://www.linkedin.com/in/kellymzhou/',
  },
  {
    name: 'Sandra Thai',
    description: "UI/UX Designer",
    image: 'https://doyourpart-assets.s3.amazonaws.com/sandra.jpg',
    link: 'https://www.linkedin.com/in/sandra-thai/',
  },
  {
    name: 'Amy Li',
    description: "UI/UX Designer",
    image: 'https://doyourpart-assets.s3.amazonaws.com/amy.jpg',
    link: 'https://www.linkedin.com/in/amyli32/',
  },

]

AboutScreen.navigationOptions = {
  header: null,
};


const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  contentContainer: {
    alignItems: 'center',
    flexGrow: 1,
    backgroundColor: '#fff',
    // paddingTop: 10
  },
  welcomeContainer: {
    alignItems: 'center',
    flex: 1,
    marginTop: 10,
    marginBottom: 20,
  },
  header :{
    flexDirection: 'row',
    alignItems: 'center',
    height: 60,
    width: '100%',
    justifyContent: 'center'
  },
  topBlurbText: {
    fontFamily: Fonts.mainFont,
    fontWeight: '600',
    alignSelf: 'flex-start',
    //paddingLeft: '8%',
    marginTop: 40,
    marginBottom: 15
  },
  lowerBlurbText: {
    fontFamily: Fonts.mainFont,
    fontSize: 18,
    //paddingTop: 20
  },
  titleText: {
    fontFamily: Fonts.mainFont,
    fontWeight: '600',
    alignSelf: 'flex-start',
    //paddingLeft: '8%',
    marginTop: 40,
    marginBottom: 5
  },
  landingImage: {
    flex: 1,
    height: 400,
    resizeMode: 'fit'
  }
});
